export default __webpack_public_path__ + "static/media/svg-2.7f6a7946.svg";